var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.userPackages),function(pkg){return _c('div',{key:pkg.id,staticClass:"mx-4 my-4",staticStyle:{"width":"400px"},attrs:{"sm":"6","md":"4"}},[_c('UserPackageDatasets',{attrs:{"userPackage":pkg},on:{"onRevokeAccess":_vm.revokeAccess}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }